import React from 'react';

export const ErrorIllustration: React.FC = () => {
  return (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 54L17.223 67.503L13 56L11.88 68.241L6 62L8.518 78H10.987H13.509H21.076H29.238L22 54Z"
        fill="#192C55"
      />
      <path
        d="M53.1929 78L54.8399 74.724C57.5179 69.398 62.9449 66 68.7749 66C72.0779 66 75.2509 67.097 77.8049 69.122L89.0009 78"
        fill="#28BF9A"
      />
      <path
        d="M73.0502 72L72.9502 78H18.9502L19.0502 72H24.0002L28.5002 58L46.4692 55L63.5002 58L67.6802 71L66.7932 71.352L68.0012 72H73.0512H73.0502ZM59.0002 44L54.5002 30L48.0002 27L37.5002 30L33.0002 44L46.9162 54L59.0002 44Z"
        fill="#FFD527"
      />
      <path d="M54.5 30H37.5L42 16H50L54.5 30ZM59 44H33L28.5 58H63.5L59 44Z" fill="#FCA760" />
      <path d="M91 78V79H5V78H91ZM67.68 71H46V72H68L67.68 71Z" fill="#192C55" />
    </svg>
  );
};
